var slideshowInterval,
	currentSlide = 0,
	slideshowSection = document.querySelector('section.slideshow'),
	images = slideshowSection ? slideshowSection.querySelectorAll('.image-slide') : 0,
	slidesLength = slideshowSection ? images.length-1 : 0;

if(slideshowSection && slidesLength > 2) {
	var slideshowWaypoint = new Waypoint({
		element: slideshowSection,
		handler: function(direction) {
			slideshowInterval = setInterval(startSlideshow, 2400);

			this.destroy();
		},
		offset: '100%'
	});

	// Play/Pause Slideshow
	slideshowSection.querySelector('.slideshow-controls').addEventListener('click', function() {
		var slideshowStopped = this.classList.contains('play');

		if(slideshowStopped)
			slideshowInterval = setInterval(startSlideshow, 2400);
		else
			clearInterval(slideshowInterval);

		this.classList.toggle('play');

		this.setAttribute('aria-label', (slideshowStopped ? 'Pause' : 'Play') + ' Slideshow');
	});
}

function startSlideshow() {
	Velocity(images[currentSlide], {opacity: [0,1]}, {duration: 800, display: currentSlide ? 'none' : 'block'});

	currentSlide = currentSlide == slidesLength ? 0 : ++currentSlide;

	Velocity(images[currentSlide], {opacity: [1,0]}, {duration: 800, display: 'block'});
}